export default __webpack_public_path__ + "2bd2f22bbd66140ec800546f5b2337d4.png";